export const getManageuserdata = [
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "Admin",

    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "prakhar mickz",
    email: "amit@123.com",
    role: "call centre agent",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "Admin",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "call centre agent",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "call centre agent",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "Admin",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "Admin",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "Admin",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "Admin",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "Admin",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "Admin",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },

  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "Admin",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "12-03-2021",
    Username: "Amit Kanth",
    email: "amit@123.com",
    role: "Admin",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
  {
    date: "09-03-2021",
    Username: "Joes khan",
    email: "joes@123.com",
    role: "Admin",
    lastLoginDateTime: "20-05-2000 03.50AM",
  },
];
export const Audittraildata = [
  {
    datetime: "20-05-2000 03.50AM",
    email: "123@gmail.com",
    action: "verify and activate card",
    actionon: "937217293",
    ipaddress: "192.168.1.1",
    role: "cell centre agent",
  },
  {
    datetime: "20-05-2000 03.50AM",
    email: "123@gmail.com",
    action: "approve benecifcery",
    actionon: "937217293",
    ipaddress: "192.168.1.1",
    role: "cell centre agent",
  },
  {
    datetime: "20-05-2000 03.50AM",
    email: "123@gmail.com",
    action: "send password",
    actionon: "937217293",
    ipaddress: "192.168.1.1",
    role: "cell centre agent",
  },
  {
    datetime: "20-05-2000 03.50AM",
    email: "123@gmail.com",
    action: "reject regstration",
    actionon: "937217293",
    ipaddress: "192.168.1.1",
    role: "cell centre agent",
  },
  {
    datetime: "20-05-2000 03.50AM",
    email: "123@gmail.com",
    action: "verify and activate card",
    actionon: "937217293",
    ipaddress: "192.168.1.1",
    role: "cell centre agent",
  },
  {
    datetime: "20-05-2000 03.50AM",
    email: "123@gmail.com",
    action: "verify and activate card",
    actionon: "937217293",
    ipaddress: "192.168.1.1",
    role: "cell centre agent",
  },
  {
    datetime: "20-05-2000 03.50AM",
    email: "123@gmail.com",
    action: "approve benecifcery",
    actionon: "937217293",
    ipaddress: "192.168.1.1",
    role: "cell centre agent",
  },
  {
    datetime: "20-05-2000 03.50AM",
    email: "123@gmail.com",
    action: "send password",
    actionon: "937217293",
    ipaddress: "192.168.1.1",
    role: "cell centre agent",
  },
  {
    datetime: "20-05-2000 03.50AM",
    email: "123@gmail.com",
    action: "reject regstration",
    actionon: "937217293",
    ipaddress: "192.168.1.1",
    role: "cell centre agent",
  },
  {
    datetime: "20-05-2000 03.50AM",
    email: "123@gmail.com",
    action: "verify and activate card",
    actionon: "937217293",
    ipaddress: "192.168.1.1",
    role: "cell centre agent",
  },
];
export const blocklistdata = [
  {
    serialnumber: "1",
    name: "Amit Kanth",
    citizenid: "323123",
  },
  {
    serialnumber: "2",
    name: "Santhosh Kumar",
    citizenid: "823123",
  },
  {
    serialnumber: "4",
    name: "Amit maran",
    citizenid: "223123",
  },
  {
    serialnumber: "6",
    name: "joes Kanth",
    citizenid: "323523",
  },
  {
    serialnumber: "7",
    name: "Amit Kanth",
    citizenid: "783123",
  },
  {
    serialnumber: "5",
    name: "uday Kanth",
    citizenid: "323123",
  },
  {
    serialnumber: "1",
    name: "Amit Kanth",
    citizenid: "123423",
  },
];
export const Referrercodedata = [
  {
    date: "10-2-21",
    name: "Amit Kanth",
    code: "AMB123",
  },
  {
    date: "12-5-21",
    name: "Josph",
    code: "AMB011",
  },
  {
    date: "10-1-21",
    name: "Amit Kanth",
    code: "AMB123",
  },
  {
    date: "10-2-21",
    name: "Amit Kanth",
    code: "AMB123",
  },
  {
    date: "12-5-21",
    name: "Josph",
    code: "AMB011",
  },
  {
    date: "10-1-21",
    name: "Amit Kanth",
    code: "AMB123",
  },
];
